import { UPLOADS, ebook, pdf } from '@/content/ebookBuilder'
import type { Ebook } from '@/content/ebookBuilder'

export const added: Ebook = ebook(
  'agentic-ai',
  'Agentic AI: A Practical Guide',
  `${UPLOADS}/2025/05/digitopia-report-agenticai-web-01-400x400.jpg`,
  {
    confirmed: true,
    download: pdf('375b51e4-7359-49da-b73f-4e5bbc8d3b88-Agentic AI - A Practical Guide.pdf'),
    // Designed as its own written page on 2026-08-28, the second after
    // Transform Better below — so the card goes there and `prerender.tsx`
    // skips it, rather than generating this template over the top of it.
    href: '/en/impact-labs/ebooks/agentic-ai',
  },
)

/** Its place in the library grid — the order the imported index listed them. */
export const order = 0
